import { render } from "./MainCards.vue?vue&type=template&id=6536ad9f&scoped=true"
import script from "./MainCards.vue?vue&type=script&lang=js"
export * from "./MainCards.vue?vue&type=script&lang=js"

import "./MainCards.vue?vue&type=style&index=0&id=6536ad9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6536ad9f"]])

export default __exports__